import { medias } from '@/utils/sizes';
import { generateClampFromMinMax } from '@/utils/styling';
import styled from 'styled-components';

export const ModalContent = styled.div`
  --form-el-height: ${generateClampFromMinMax(55, 88)};

  display: flex;
  flex-direction: column;
  gap: var(--spacing-component-inner);
  background: white;
  width: ${generateClampFromMinMax(500, 700)} !important;
  padding: ${generateClampFromMinMax(40, 60)} !important;
  z-index: 1;

  ${medias.max.mobile} {
    padding-left: var(--page-pd-mobile-tablet);
    padding-right: var(--page-pd-mobile-tablet);
    width: 90vw;
  }
`;

export const Button = styled.button`
  all: unset;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  height: var(--form-el-height);
  width: 100%;
  background-color: var(--c-black);
  color: var(--c-white);
  font-size: var(--fs-lg);
`;

export const ButtonsContainer = styled.div`
  display: grid;
  box-sizing: border-box;
  grid-template-columns: 1fr 1fr;
  column-gap: var(--spacing-component-inner-xs);

  button:first-of-type {
    background-color: transparent;
    border: 1px solid var(--c-black);
    color: var(--c-primary);
  }
`;
